import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

class VoyageSummarySvc {
  constructor() {
    this.api = axiosInstance.create({
      baseURL: process.env.VUE_APP_API_URL,
    });
  }

  async getAll(params) {
    try {
      const res = await this.api.get('/voyage/summary', {
        params,
        cancelToken: getNewCancelToken(),
      });
      return res.data;
    } catch (err) {
      return Promise.reject(err);
    }
  }

  // Summary selesai dalam satu request; status yang mungkin cuma 4 (selesai)
  // dan 5 (gagal).
  async fetchById(mvygId) {
    try {
      const res = await this.api.get(`/voyage/summary/fetch/${mvygId}`, {
        cancelToken: getNewCancelToken(),
      });
      const { status, data } = res.data;

      // Gagal dibalikin HTTP 200 + envelope error, bukan lewat catch axios.
      if (status?.error) {
        throw Object.assign(
          new Error(status.message || 'Failed to fetch voyage summary'),
          { errorCode: status.errorCode },
        );
      }

      const { report } = data;
      if (report.rprtStatus === 5) {
        throw new Error(report.rprtError || 'Failed to generate voyage summary');
      }

      return report.rprtData;
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

export default new VoyageSummarySvc();
